<template>
  <div>
    <v-layout align-center justify-center>
      <v-flex xs12 sm12 md12 lg12 style="max-width: 350px">
        <div class="logo">
          <img src="../../assets/logo.png" id="form" />
        </div>
        <div v-if="isError" class="errors">{{ responseError }}</div>
        <v-form autocomplete="disabled">
          <v-icon slot="prepend" color="red">mdi-plus</v-icon>

          <v-text-field
            placeholder=" "
            id="email"
            autocomplete="email"
            prepend-icon="mdi-account"
            spellcheck="false"
            label="Email"
            name="loginEmail"
            type="text"
            :rules="
              !errors.first('loginEmail')
                ? [true]
                : [errors.first('loginEmail')]
            "
            :error-messages="errors.collect('loginEmail')"
            v-model="email"
            v-validate.lazy="{ required: true, email: true }"
          ></v-text-field>

          <v-text-field
            placeholder=" "
            autocomplete="password"
            prepend-icon="mdi-lock"
            v-validate.lazy="{ required: true }"
            id="password"
            label="Password"
            name="loginPass"
            type="password"
            :rules="
              !errors.first('loginPass') ? [true] : [errors.first('loginPass')]
            "
            :error-messages="errors.collect('loginPass')"
            v-model="password"
          ></v-text-field>
        </v-form>

        <v-card-actions class="mt-3">
          <v-spacer></v-spacer>
          <div class="holder">
            <div></div>
            <v-btn color="#005550" dark="" width="100" @click="loginRequest"
              >Login</v-btn
            >
          </div>
        </v-card-actions>
      </v-flex>
    </v-layout>
    <v-overlay z-index="555" opacity=".7" :value="load">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- </v-container> -->
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import firebase from "firebase/app";
import "firebase/auth";
import { TokenService } from "../../services/storage.service";
import { ACTION_LOGIN, IS_LOGGED_IN } from "../../store/constants/user";
export default {
  name: "Home",
  data() {
    return {
      load: false,
      isError: false,
      responseError: "",
      email: "",
      password: "",
      twoFactor: undefined,
    };
  },
  methods: {
    ...mapActions({
      login: ACTION_LOGIN,
    }),

    resetAllVars(param) {
      this.email = "";
      this.password = "";
    },
    enterEventListener(e) {
      if (e.keyCode === 13) {
        this.loginRequest();
      }
    },

    async loginRequest() {
      this.load = true;
      this.isError = false;
      const validator = await this.$validator.validate();
      if (validator) {
        try {
          await firebase
            .auth()
            .signInWithEmailAndPassword(this.email, this.password)
            .then((res) => {
              TokenService.saveConfig({
                email: res.user.email,
              });
            });
          this.login({email:this.email});
        } catch (error) {
          this.isError = true;
          this.responseError = error;
        } finally {
          this.load = false;
        }
      } else {
        this.load = false;
      }
    },
  },

  mounted() {
    document.body.addEventListener("keyup", this.enterEventListener);
  },
  beforeDestroy() {
    document.body.removeEventListener("keyup", this.enterEventListener);
  },
};
</script>

<style lang="scss" scoped>
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus input:-webkit-autofill,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  box-shadow: 0 0 0px 1000px #f9f9f9 inset !important;
  -webkit-box-shadow: 0 0 0px 1000px #f9f9f9 inset !important;
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 70px;
}
img {
  width: 152px;
  height: 32px;
}
.errors {
  font-size: 12px;
  color: red;
  margin-left: 30px;
  margin-bottom: 15px;
}
.holder {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  & > div {
    font-size: 13px;
    color: #006bc7;
    cursor: pointer;
    &:hover {
      color: #00bc70;
    }
  }
}
</style>
